export default __webpack_public_path__ + "static/media/about_three.0fc61af6.png";